const ProjectsData = [
    {
        id: 1,
        title: 'Portfolio V1',
        image: './images/projects/project1.png',
        description: [
            'Ce projet est la première version de mon portfolio.',
            'Les informations sont fictives et servent uniquement à illustrer le design.'
        ],
        link: 'https://nolan.3ntf.fr/',
        languages: ['React', 'Sass']
    },
    {
        id: 2,
        title: 'MARPA',
        image: './images/projects/project2.png',
        description: [
            'Développement du site d\'une MARPA où travaille une connaissance.',
            'L\'objectif était de faire une refonte du site existant, en le modernisant.'
        ],
        link: 'https://marpa.vercel.app/index.html',
        languages: ['JS', 'CSS', 'HTML']
    },
    {
        id: 3,
        title: 'Bumble-B',
        image: './images/projects/project3.png',
        description: [
            "Création d'une application mobile de course.",
            'Permet de piloter un véhicule et récupérer ses données durant des courses.'
        ],
        link: 'https://github.com/Nolan-ramos/Bumble-B.git',
        languages: ['React', 'CSS']
    },
    {
        id: 4,
        title: 'Portfolio pour un ami',
        image: './images/projects/project4.png',
        description: [
            'Développement d\'un portfolio pour un ami.',
            'Les informations sont fictives et servent uniquement à illustrer le design.'
        ],
        link: 'https://portfolio-ami.vercel.app/',
        languages: ['JS', 'CSS', 'HTML']
    },
];

export default ProjectsData;